import React from "react"
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap"
import DountChart from "pages/Chartsjs/dountchart"
import BarChartV2 from "./barchartv2"
import { useTranslation } from "react-i18next"
import { hasValidChartData } from "../dashboardChartOptions"
import ReportsDashboardv2 from "./ReportsDashboardv2"
import GenderSummaryCard from "./GenderSummaryCard"

import { useSelector } from "react-redux"
import { layoutModeTypes } from "constants/layout"
import TrialWorkerSummaryCard from "./TrialWorkerSummaryCard"
import Colors from "constants/Colors"
import IconifyIcon from "components/Shared/IconifyIcon"

const GeneralstatisticsV2 = ({
  chartConfigs = [],
  data,
  options,
  dashboardData,
}) => {
  const { t } = useTranslation()
  const layoutMode = useSelector(state => state.Layout.layoutModeType)
  const borderColor =
    layoutMode === layoutModeTypes.LIGHT ? "#D6D6D6" : "#383838"

  const dountChartOptions = {
    cutout: "80%",
    plugins: {
      legend: {
        onClick: null,
        position: "bottom",
        labels: {
          usePointStyle: true,
          boxWidth: 10,
          boxHeight: 10,
          padding: 5,
          font: { size: 12 },
          generateLabels: chart => {
            const { data } = chart
            return data.labels.map((label, i) => ({
              text: `${label} ${data.datasets[0].data[i].toLocaleString()}`, // Adds commas
              fillStyle: data.datasets[0].backgroundColor[i],
              fontColor:
                layoutMode === layoutModeTypes.LIGHT
                  ? Colors.black
                  : Colors.white,
              hidden: false,
              index: i,
              strokeStyle: data.datasets[0].backgroundColor[i],
              pointStyle: "rect",
            }))
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const dataset = tooltipItem.dataset.data
            const total = dataset.reduce((acc, num) => acc + num, 0)
            const value = dataset[tooltipItem.dataIndex]
            const percentage = ((value / total) * 100).toFixed(1)

            return [
              `${t("Total Count")}: ${value.toLocaleString()}`,
              `${t("Percentage")}: ${percentage}%`,
            ]
          },
        },
      },
      datalabels: {
        display: false,
      },
    },
  }

  return (
    <Card>
      <CardBody>
        <Row data-page-section="true">
          <Col lg={12}>
            <ReportsDashboardv2 dashboardData={dashboardData} />
          </Col>
        </Row>
        <Row data-page-section="true">
          {chartConfigs.map(({ title, data }) => {
            if (title === "Gender") return null
            return (
              <Col xl={4} key={title}>
                <Card style={{ border: `1px solid #7E8492` }}>
                  <CardBody>
                    <CardTitle
                      style={{
                        color:
                          layoutMode === layoutModeTypes.DARK
                            ? Colors.white
                            : Colors.black,
                      }}
                    >
                      {t(title)}
                    </CardTitle>
                    {hasValidChartData(data) ? (
                      <div className="ltr">
                        <DountChart data={data} options={dountChartOptions} />
                      </div>
                    ) : (
                      <div className="g_center h-75">
                        <h5
                          style={{
                            color:
                              layoutMode === layoutModeTypes.DARK
                                ? Colors.white
                                : Colors.black,
                          }}
                        >
                          {t("No Data Available")}
                        </h5>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            )
          })}
          <Col md={7} sm={12}>
            <Card style={{ border: "1px solid #7E8492" }}>
              <CardBody>
                <div className="d-flex align-items-center gap-2">
                  <IconifyIcon
                    width={24}
                    height={24}
                    icon="solar:user-outline"
                    style={{
                      color:
                        layoutMode === layoutModeTypes.LIGHT
                          ? Colors.primary
                          : Colors.primaryLight,
                    }}
                  />
                  <h4
                    className="mt-2"
                    style={{
                      fontWeight: "700",
                      color:
                        layoutMode === layoutModeTypes.LIGHT
                          ? Colors.black
                          : Colors.white,
                    }}
                  >
                    {t("Age")}
                  </h4>
                </div>

                <div className="ltr">
                  <BarChartV2 data={data} options={options} height={600} />
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col md={5} sm={12}>
            <Row>
              <Col sm={12}>
                <Card style={{ border: "1px solid #7E8492" }}>
                  <CardBody>
                    <GenderSummaryCard
                      stats={dashboardData?.male_or_female_stats}
                    />
                  </CardBody>
                </Card>
              </Col>
              <Col sm={12}>
                <Card style={{ border: "1px solid #7E8492" }}>
                  <CardBody>
                    <TrialWorkerSummaryCard
                      stats={dashboardData?.work_in_trial_period}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export default GeneralstatisticsV2
